import styled from 'styled-components'

export const Container = styled.div<{ $isOpen: boolean }>`
  display: ${(props) => (props.$isOpen ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 2rem;
`

export const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.pureBlack};
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Content = styled.div`
  width: 67%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: auto;
  -webkit-overflow-scrolling: auto;
  border-radius: 2rem;
  margin: auto;
  background-color: ${({ theme }) => theme.colors.pureWhite};
`
